import { Section } from 'types/faq'
import { Question } from 'types/faq'

export type FaqProps = {
  sections: Section[]
  questions: Question[]
}

export type FAQApiResponse = {
  sections: Section[]
  questions: Question[]
}

export enum FAQCategories {
  COMMON = 'common',
  MINI_GENERATORS = 'mini_generators',
  PRICE_INCREASE = 'price_increase'
}
